import React, { useEffect } from "react";
import Header from "../../Components/Header/Header";
import CustomDropdown from "../../Components/DropDown/CustomDropdown";
import Icons from "../../Constants/Icons";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../Config/Actions/loadingActions";
import {
  apiCallDeleteArtistTypes,
  apiCallStatusChangeArtistTags,
  apiCallUserArtistType,
} from "../../Core/Apicall";
import EmptyData from "../../Components/EmptyData/EmptyData";
import "../CategoryManagement/style.css";
import { CustomCommonBox } from "../../Components/CustomCommonBox/CustomCommonBox";
import Colors from "../../Constants/Colors";
import ArtisticModal from "./ArtisticModal";
import CustomArtisticTag from "../../Components/CustomArtisticTag/CustomArtisticTag";


function ArtisticTag() {
  const dispatch = useDispatch();
  const statusDropdownItem = ["All", "Activate", "Deactivate"];
  const [editData, setEditData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [artisticData, setArtisticTagData] = useState();
  const [artisticAllData, setArtisticTagAllData] = useState();
  const [dropdownLabelSelect, setDropdownLabelSelect] = useState("By Status");
  const [searchValue, setSearchValue] = useState("");
  const [tagsTotalActive, setArtisticTotalActive] = useState(0);
  const [tagsTotalInActive, setArtisticTotalInActive] = useState(0);
  const [tagsTotalCount, setArtisticTotalCount] = useState(0);

  useEffect(() => {
    onApiCallArtisticsList(0);
  }, []);

  const onApiCallArtisticsList = async () => {
    setSearchValue("")
    dispatch(setLoadingTrue());
    const param = {
      status: null,
    };
    try {
      const res = await apiCallUserArtistType(param);
      setArtisticTotalActive(res.allActiveTags ?? 0);
      setArtisticTotalInActive(res.allDeActiveTags ?? 0);
      setArtisticTotalCount(res.allTagsTotal ?? 0);
      setDropdownLabelSelect("By Status");
      setArtisticTagData(res);
      setArtisticTagAllData(res);
      dispatch(setLoadingFalse());
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };

  const addNewTags = () => {
    setShowModal(true);
    setEditData(null);
  };
  const handleCloseModal = () => {
    setEditData();
    setShowModal(false);
  };

  const handleEditClick = (selectedData) => {
    setShowModal(true);
    setEditData(selectedData);
  };

  const handleSelect = (status) => {
    setDropdownLabelSelect(status);
    if (status === "All") {
      setArtisticTagData(artisticAllData);
    } else {
      const filteredData = artisticAllData.data.filter((item) =>
        status === "Activate"
          ? item.isEnabled === true
          : item.isEnabled === false
      );
      setArtisticTagData({ ...artisticAllData, data: filteredData });
    }
  };

  const handleInputChange = (e) => {
    const searchText = e.target.value;
    setSearchValue(searchText);
    searchFilterFunction(searchText);
  };

  const searchFilterFunction = async (text) => {
    setDropdownLabelSelect("By Status");
    const searchText = text.trim().toLowerCase();
    if (searchText) {
      const newData = artisticAllData.data.filter((item) =>
        item.ArtistType?.toLowerCase().includes(searchText)
      );
      console.log("newData", newData);
      setArtisticTagData({
        ...artisticAllData,
        data: newData,
      });
    } else {
      setArtisticTagData(artisticAllData);
    }
  };

  const onClickToggleStatusChange = async (data) => {
    dispatch(setLoadingTrue());
    const param = {
      _id: data._id,
      isEnabled: !data.isEnabled,
    };
    try {
      await apiCallStatusChangeArtistTags(param);
      dispatch(setLoadingFalse());
      if (data.isEnabled) {
        setArtisticTotalActive((prev) => prev - 1);
        setArtisticTotalInActive((prev) => prev + 1);
      } else {
        setArtisticTotalActive((prev) => prev + 1);
        setArtisticTotalInActive((prev) => prev - 1);
      }
      setArtisticTagData((prevData) => {
        const updatedData = prevData.data.map((item) => {
          if (item._id === data._id) {
            return { ...item, isEnabled: !item.isEnabled };
          }
          return item;
        });
        return { ...prevData, data: updatedData };
      });
      setArtisticTagAllData((prevData) => {
        const updatedData = prevData.data.map((item) => {
          if (item._id === data._id) {
            return { ...item, isEnabled: !item.isEnabled };
          }
          return item;
        });
        return { ...prevData, data: updatedData };
      });
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };
  const handelDelete = async (selectedData) => {
    dispatch(setLoadingTrue());
    const param = {
      _id: selectedData._id,
    };
    try {
      await apiCallDeleteArtistTypes(param);
      if (selectedData.isEnabled) {
        setArtisticTotalActive((prev) => prev - 1);
      } else {
        setArtisticTotalInActive((prev) => prev - 1);
      }
      setArtisticTotalCount((prev) => prev - 1);
      setArtisticTagData((prevData) => ({
        ...prevData,
        data: prevData.data.filter((item) => item._id !== selectedData._id),
      }));
      setArtisticTagAllData((prevData) => ({
        ...prevData,
        data: prevData.data.filter((item) => item._id !== selectedData._id),
      }));
      dispatch(setLoadingFalse());
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };

  const eventTotal = [
    {
      id: 1,
      name: "Total Artistic Tag",
      value: tagsTotalCount,
    },
    {
      id: 2,
      name: "Total Activate",
      value: tagsTotalActive,
      color: Colors.darkGreen,
    },
    {
      id: 3,
      name: "Total Deactivate",
      value: tagsTotalInActive,
      color: Colors.darkBlue,
    },
  ];
  return (
    <div className="Category-Event">
      <Header name={"Artistic Tag"} />
      <div className="Event-AlignSelf">
        <div className="lastWeekEndDiv Event-AlignSelf-stretch ">
          <div className="astrologer-inner">
            <div className="frame-container">
              <div className="frame-div">
                {eventTotal.map((item) => (
                  <CustomCommonBox
                    key={item.id}
                    label={item.name}
                    count={item.value}
                    color={item.color}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="astrologers-list-parent padding-top-bottom">
        <div className="frame-parent2">
          <div className="custom-box-user">
            <div className="category_button">
              <button onClick={addNewTags}>Add New Tag </button>
            </div>
            <div className="custom-container-dropdown-div">
              <CustomDropdown
                dropDownLabel={dropdownLabelSelect}
                items={statusDropdownItem}
                color="blue"
                onSelect={handleSelect}
                customLabelStyle={{
                  fontWeight: "400",
                  color: "white",
                }}
              />
            </div>

            <div className="custom-box-search-div">
              <img className="custom-image" alt="" src={Icons.ic_search} />
              <input
                type="text"
                className="searchTextInput"
                placeholder="Search"
                value={searchValue}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <ArtisticModal
          show={showModal}
          editData={editData}
          handleClose={handleCloseModal}
          pageRefresh={() => onApiCallArtisticsList(0)}
        />
      )}
      <div className="mainDarkColor Event-custom-style">
        <div className="lastWeekEndDiv Total-Event">
          <div className="user_title event-flex-container">
            Artistic Tag List
          </div>
          <div className="transparentWhite">
            <nav className="grid-cols grid_7 fontSize16WithoutFlex transparentWhite-padding">
              <div className="category_w">Artistic Tag</div>
              <div className="category_w">Status</div>
              <div className="category_w">Edit</div>
              <div className="category_w">Delete</div>
            </nav>
            <CustomArtisticTag
              currentArtisticTags={artisticData?.data}
              onClickToggleStatusChange={onClickToggleStatusChange}
              onEditClick={handleEditClick}
              handelDelete={handelDelete}
            />
          </div>
        </div>
      </div>

      {artisticData?.data?.length === 0 && (
        <div className="empty-centered">
          <EmptyData />
        </div>
      )}
    </div>
  );
}
export default ArtisticTag;
